import { tokens } from '@/lib/tokens.js';

export function NotFoundPage() {
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        fontFamily: tokens.font.sans,
        color: tokens.colors.textDark,
      }}
    >
      <p
        style={{
          color: tokens.colors.primary,
          fontSize: '4rem',
          fontWeight: 700,
          margin: '0 0 0.5rem',
        }}
      >
        404
      </p>
      <h1
        style={{
          fontSize: '1.5rem',
          fontWeight: 600,
          marginBottom: '0.75rem',
          color: tokens.colors.textDark,
        }}
      >
        Página no encontrada
      </h1>
      <p
        style={{ color: tokens.colors.textMutedDark, marginBottom: '1.5rem', textAlign: 'center' }}
      >
        La página que buscas no existe o no tienes permisos para verla.
      </p>
      <a
        href="/catalog"
        style={{
          backgroundColor: tokens.colors.primary,
          color: '#fff',
          borderRadius: tokens.radius.button,
          padding: '0.5rem 1.5rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          textDecoration: 'none',
        }}
      >
        Ir al catálogo
      </a>
    </main>
  );
}
